import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import Paper from 'components/Paper'

import styles from './index.css'


const Z_INDEX_BASE = 101

@withRouter
export default class Modal extends React.Component {
  
  static propTypes = {
    open: PropTypes.bool.isRequired,
    zIndex: PropTypes.number,
  }

  static defaultProps = {
    open: false
  }

  constructor(props) {
    super(props)
  }

  render() {
    if (!this.props.open) return null
    const zz = {}
    if (this.props.zIndex) {
      zz.style = {
        zIndex: Z_INDEX_BASE + this.props.zIndex
      }
    }
    return (
      <div className={styles.ModalOverlay} {...zz}>
        <div className={styles.ModalContainer}>
          <Paper>
            {this.props.open && this.props.children}
          </Paper>
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/Modal/index.jsx